export default "__VITE_ASSET__CgAyy8$6__"